import { combineReducers } from "redux";
import Alldata from "./Alldata";
import HandleNext from "./HandleNext";

const reducers = combineReducers({
  Next: HandleNext,
  Alldata: Alldata,
});
export default reducers;
